import { Pipe, PipeTransform } from '@angular/core';
import { WorkflowStatusMeta } from './core/interface';
import {
  Partners,
  QuoteType,
  QuoteWorkflowStatus,
} from '@lockton-apps/shared/interfaces';
import { getEnquiryQuoteWorkflowMeta } from './core/enquiry-quote-workflow-meta';

@Pipe({
  name: 'enquiryQuoteWorkflowMeta',
  standalone: true,
})
export class EnquiryQuoteWorkflowMetaPipe implements PipeTransform {
  transform(
    status: QuoteWorkflowStatus,
    quoteType: QuoteType,
    partner?: Partners
  ): WorkflowStatusMeta {
    return getEnquiryQuoteWorkflowMeta(status, quoteType, partner);
  }
}
